import { Dispatch, RefObject, SetStateAction, useEffect } from 'react';

type Props = {
  selectRef: RefObject<HTMLDivElement | null>;
  inputRef: RefObject<HTMLInputElement | null>;
  lockActiveState: boolean;
  setSearchValue: Dispatch<SetStateAction<string>>;
};

const useScrollResets = ({ selectRef, lockActiveState, inputRef, setSearchValue }: Props) => {
  useEffect(() => {
    const selectEl = selectRef?.current;
    if (!selectEl) return;

    if (lockActiveState) {
      // scroll to right
      selectEl.scrollTo({
        left: selectEl?.scrollWidth || 0,
      });
    } else {
      if (inputRef?.current) {
        inputRef.current.value = '';
        const parentNode = inputRef?.current?.parentNode;
        if (parentNode instanceof HTMLElement) {
          parentNode.setAttribute('data-value', '');
        }
      }
      setSearchValue('');

      // scroll to left
      selectEl.scrollTo({
        left: 0,
      });
    }
  }, [inputRef, lockActiveState, selectRef, setSearchValue]);
};

export default useScrollResets;
